import { useMutation } from 'react-query';
import { Feedback, FeedbackBodyParams } from '@repo/types/feedback';
import { httpClient } from '../../../utils/http/http-client';

export const usePostFeedback = (id: number) =>
  useMutation({
    mutationKey: ['postFeedback'],
    mutationFn: (params: FeedbackBodyParams) =>
      httpClient.POST<FeedbackBodyParams, Feedback>(
        `release/${id}/feedback`,
        params,
      ),
  });
